// extracted by mini-css-extract-plugin
export default {"close":"SuccessTransaction_close__EuhFm","content":"SuccessTransaction_content__OMfcR"};